import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const WorkFlowCategoryService = {
  state: {},

  mutations: {},

  actions: {
    workflowCategoryList({ commit }, type) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflowCategory/list', { type: type }).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowCategorySave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowCategory/save', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowCategoryRemove({ commit }, ids) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflowCategory/remove', ids).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowCategoryUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflowCategory/${params.id}/update`, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}

export default WorkFlowCategoryService
